// ====================================================================
// CLIENT FOLLOW-UP CRM - USER MANAGEMENT VIEW (ADMIN ONLY)
// ====================================================================

import { getUsers, updateUserRole } from '../store.js';
import { escapeHtml, formatDate, showToast } from '../ui.js';

export async function renderUsersView(container) {
  const users = await getUsers();

  container.innerHTML = `
    <div class="page-header">
      <div>
        <h1 class="page-title">User & Role Management</h1>
        <p class="page-subtitle">Assign user roles (Admin vs Staff) and manage team permissions</p>
      </div>
    </div>

    <div class="card">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>User Name</th>
              <th>Email Address</th>
              <th>Current Role</th>
              <th>Created Date</th>
              <th style="text-align: right;">Change Role</th>
            </tr>
          </thead>
          <tbody>
            ${users.map(u => `
              <tr>
                <td><strong>${escapeHtml(u.name)}</strong></td>
                <td>${escapeHtml(u.email)}</td>
                <td><span class="user-role-badge ${u.role}">${escapeHtml(u.role)}</span></td>
                <td>${formatDate(u.created_at)}</td>
                <td style="text-align: right;">
                  <select class="form-select user-role-select" data-id="${u.id}" style="width:auto; display:inline-block; padding:0.25rem 0.5rem; font-size:0.8rem;">
                    <option value="staff" ${u.role === 'staff' ? 'selected' : ''}>Staff</option>
                    <option value="admin" ${u.role === 'admin' ? 'selected' : ''}>Admin</option>
                  </select>
                </td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    </div>
  `;

  document.querySelectorAll('.user-role-select').forEach(sel => {
    sel.addEventListener('change', async (e) => {
      const userId = e.target.dataset.id;
      const newRole = e.target.value;
      try {
        await updateUserRole(userId, newRole);
        showToast(`User role updated to ${newRole}`, 'success');
        renderUsersView(container);
      } catch (err) {
        showToast(err.message || 'Failed to update role', 'error');
      }
    });
  });
}
